// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"2754":"a3d6f4909122e049","2937":"5e6f1007026be5ab","5279":"271443d477bb12c8","7127":"98ead86c4816dbfb","7229":"57895636e2064bb4","8915":"1f1b7eb109ec8287"}[chunkId] + ".js";
};